import { useSelector } from "react-redux"
import useIsAdmin from './useIsAdmin';

const useShowReturnsMenuItem = () => {
  const isAdmin = useIsAdmin();

  const isProductReturnEnabled = useSelector(state => (
    state?.page?.crtFormItem?.isProductReturnEnabled ||
    state?.user?.isProductReturnEnabled
  ));
  
  return isAdmin || isProductReturnEnabled;
};

export default useShowReturnsMenuItem;